/* eslint-disable security/detect-object-injection */
import { createSlice } from '@reduxjs/toolkit';

export const STALE_THRESHOLD_MS = 5 * 60 * 1000;

const initialState = {
    free_user: '',
    plan_type: '',
    email_address: '',
    lastFetchedAt: null,
    isFetching: false,
};
/* The code is creating a slice of the Redux store called `pricingSlice`. */
const pricingSlice = createSlice({
    name: 'pricing',
    initialState,
    reducers: {
        updatePricingValue: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
            if(field==='plan_type'){
                localStorage.setItem('plan_type',value);
            }
        },
        setFetching: (state, action) => {
            state.isFetching = action.payload;
        },
        profileFetchSucceeded: (state, action) => {
            state.plan_type = action.payload.plan_type;
            state.free_user = action.payload.free_user;
            state.email_address = action.payload.email_address;
            state.lastFetchedAt = Date.now();
            state.isFetching = false;
            localStorage.setItem('plan_type', action.payload.plan_type);
        },
    }
})
export const { updatePricingValue, setFetching, profileFetchSucceeded } = pricingSlice.actions;
export default pricingSlice.reducer;

